import Icon from "~/ui/Icon";
import NavigationLink from "~/ui/NavigationLink";
import ROUTES from "~/kernel/routing/ROUTES";

export default function HelpLink() {
  return (
    <NavigationLink activatable to={ROUTES.help.path()}>
      <Icon
        name="circle-question"
        className="text-2xl md:!text-xl"
        aria-label="Gå till hjälpavsnitt"
      />
    </NavigationLink>
  );
}
